var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayerFlex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13.5,
    r: 13.5,
    fill: "#464444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4063 12.634C21.0729 13.0189 21.0729 13.9811 20.4063 14.366L11.5469 19.481C10.8802 19.8659 10.0469 19.3848 10.0469 18.615L10.0469 8.38504C10.0469 7.61524 10.8802 7.13411 11.5469 7.51901L20.4063 12.634Z",
    fill: "#FBF9F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerFlex);
export default __webpack_public_path__ + "static/media/player-flex.f7d84147608acbef0db148b37439c863.svg";
export { ForwardRef as ReactComponent };